import { addDays, startOfDay } from "./_date-fns";
import type { Time } from "./time";

export function startOfNextDay(time: Time): Date {
	return startOfDay(addDays(time, 1));
}
